import { useRedux } from "hooks";
import React, { useEffect, useRef, useState } from "react";
import {
    Form,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Input,
    Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import Loader from "./Loader";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync } from "../api/chats";
import { findDconnectWebUser } from "../redux/profile2/p2_reducer";
import { addUserToGroup, getChatUserDetails2s } from "../redux/actions";
import { Exception } from "sass";
import { Utils } from "helpers/utils";
import FormInput from "./FormInput";
import UserAvatar from "./UserAvatar";
import { debounce } from "lodash";
import TxtAtoFindUser from "./TxtAtoFindUser";
import { APIClient } from "api/apiCore";



interface SearchWebUserModalProps {
    isOpen: boolean;
    onClose: () => void;
    groupId: number;
    selectedMemberId: any;
}

const SearchWebUserModal = ({
    isOpen,
    onClose,
    groupId,
    selectedMemberId
}: SearchWebUserModalProps) => {

    const { dispatch, useAppSelector } = useRedux();
    const storeData = createSelector(
        (state) => state.Profile2,
        (state) => ({
            // groupInviteCode: state.groupInviteCode,
            // groupInviteOn: state.groupInviteOn,
            profile2: state,
            findDConnectUsers: state.findDConnectUsers,
            findDConnectUserOn: state.findDConnectUserOn

        })
    );
    const { /*groupInviteCode, groupInviteOn,*/ profile2, findDConnectUsers, findDConnectUserOn } = useAppSelector(storeData);
    // console.log('profile2:', profile2);
    const [isGenCode, setIsGenCode] = useState<boolean>(false);
    const [errMessage, _a1] = useState<string>("");
    const [errClass, _a2] = useState<string>("danger");
    const [groupInviteCode, setGroupInviteCode] = useState('');
    const [toggleLoadGroupInfo, setToggleLoadGroupInfo] = useState<boolean>(false);
    const [userInfo, setUserInfo] = useState<any>(null);
    // console.log('profile2:', profile2);

    useEffect(() => {
        // const api = new APIClient()
        // const fetch = async (memberId:any) => {

        // }
        // fetch(selectedMemberId);
        // console.log('groupId:', groupId);
        // console.log({ groupId, selectedMemberId, toggleLoadGroupInfo });
        dispatch(findDconnectWebUser(groupId, lastFilter));
        const api = new APIClient()
        const arg = { userOrGroupId: groupId, chatUserId: selectedMemberId };
        // console.log('get-cus-web-user-info -> arg:', arg);
        if (selectedMemberId) { // 20250306 add if have selectedMemberId to prevent multiple call to backend
            api.fnPostForm("/get-cus-web-user-info", arg)
                .then(response => {
                    // console.log('get-cus-web-user-info":',response);
                    setUserInfo(response);
                })
                .catch(err => console.error(err));
        }
    }, [groupId, selectedMemberId, toggleLoadGroupInfo]);


    // useEffect(() => {
    //     console.log('OnSearchWebUserModalShow:', { selectedMemberId, userInfo, findDConnectUsers })
    // }, [selectedMemberId, userInfo, findDConnectUsers]);

    const onModalClose = () => {
        onClose();
    }

    const debounceFindDconnectWebUser = debounce((filter) => {
        dispatch(findDconnectWebUser(groupId, filter));
    }, 800); // Adjust the debounce time as necessary      

    const [lastFilter, setLastFilter] = useState("");

    const onFilter = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setLastFilter(newValue);
        debounceFindDconnectWebUser(newValue);
        // dispatch(findDconnectWebUser(newValue));
    }

    const onAddMember = async (userId: number) => {
        dispatch(addUserToGroup(groupId, userId, true));
    }

    const spnChatMemberInfo = useRef<any>(null);

    const onApplyWebUserToChat = async (webUserId: any, webUserName: any, webUserCompany: any) => {

        const chatMemberInfo = spnChatMemberInfo?.current?.innerText;
        const webUserInfo = "ชื่อ: " + webUserName + ", ลูกค้า: " + webUserCompany;
        // console.log({groupId, selectedMemberId, webUserId, chatMemberInfo, webUserName});
        const msgConfirm = webUserId == -1
            ? `ยกเลิกจับคู่ผู้ใช้ในแชท<br/><u class="text-red">${chatMemberInfo}</u></br>กับผู้ใช้ใน <span class="text-primary">${userInfo?.appName}</span></br><u class="text-red">${webUserInfo}</u></br>ใช่หรือไม่`
            : `จับคู่ผู้ใช้ในแชท<br/><u class="text-red">${chatMemberInfo}</u></br>กับผู้ใช้ใน <span class="text-primary">${userInfo?.appName}</span></br><u class="text-red">${webUserInfo}</u></br>ใช่หรือไม่`;
        Utils.SweetConfirm(msgConfirm)
            .then((result) => {
                if (result.isConfirmed) {
                    const api = new APIClient()
                    api.fnPostForm("/apply-web-user-to-chat-user", {
                        chatGroupId: groupId, chatUserId: selectedMemberId, webUserId: webUserId
                    })
                        .then(response => {
                            // alert('จับคู่สำเร็จ');
                            dispatch(getChatUserDetails2s(groupId, false, true, false));
                            setToggleLoadGroupInfo((prev) => !prev);
                            dispatch(findDconnectWebUser(groupId, lastFilter));
                            onModalClose();
                            // console.log(response);
                            // setGroupInfo(response)
                        })
                        .catch(err => {
                            alert('มีข้อผิดพลาด');
                            console.error(err)
                        });
                    // dispatch(delGroupFromUser(gruopId, userId));
                    // if (gruopId == selectedChat) {
                    //     console.log('onRemoveGroup.selectedChat = null');
                    //     dispatch(changeSelectedChat(null));
                    // }
                    // try { -> move to saga
                    //     dispatch(getChatRoomLists());
                    // } catch (e) {
                    //     alert((e as Error).message);
                    // }
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return (
        <Modal isOpen={isOpen} toggle={onModalClose} tabIndex={-1} centered scrollable size="xl" >
            <ModalHeader className="bg-primary" toggle={onModalClose}>
                <div className="modal-title-custom text-white font-size-16 ">
                    เลือกผู้ใช้งานจาก {userInfo?.appName}
                    &nbsp;{findDConnectUserOn && (<Spinner size={"sm"} />)}

                </div>
            </ModalHeader>
            <ModalBody className="p-4 ">
                <Form>
                    {errMessage && (
                        <div className="mb-3">
                            <div className={"alert alert-" + errClass + " text-center"}>{errMessage}</div>
                        </div>
                    )}
                    <div className="mb-3">
                        {/* <span onClick={fnTest}>content</span> */}
                        <div className="row">
                            <div className="col">
                                ผู้ใช้งานในระบบ แชท :&nbsp;
                                <span ref={spnChatMemberInfo} className={Utils.GetCssSuffixTheme("spn-info-hilight")}>
                                    [{userInfo?.chatMemberId}]&nbsp;
                                    {userInfo?.chatMemberName}, โทร {userInfo?.chatMemberMobile}, ห้องแชท {userInfo?.chatGroupName}
                                </span>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                ผู้ใช้งานในระบบ {userInfo?.appName} :&nbsp;
                                {userInfo?.webUserId
                                    ? (
                                        <>
                                            <span className={Utils.GetCssSuffixTheme("spn-info-hilight")}>
                                                [{userInfo?.webUserId}]&nbsp;
                                                {userInfo?.webUserName ?? "ไม่มีชื่อ"}, โทร {userInfo?.webUserMobile ?? "ไม่มีเบอร์"}
                                            </span>
                                            <span className="hand text-danger p-2" onClick={() => onApplyWebUserToChat(-1, userInfo?.webUserName, userInfo?.customerNameErp)}>เลิกจับคู่</span>
                                        </>
                                    )
                                    : (<span className="text-red" >ยังไม่ได้จับคู่</span>)
                                }
                            </div>
                        </div>
                        <div className="row pt-2">
                            <div className="col">
                                <i style={{ "color": "gray" }}>
                                    เลือก ผู้ใช้ <span className="text-red">{userInfo?.appName}</span> จากบริษัท <span className="text-red">{userInfo?.companyId}:{userInfo?.customerNameErp} </span>
                                    เพื่อจับคู่กับ ผู้ใช้ในระบบ chat </i>
                            </div>
                        </div>
                        {/* // 20250508 No need to use filter, because user is few and reload every time
                            <FormInput
                            type="text"
                            name="filter"
                            errors={"hello"}
                            placeholder="ชื่อ/เบอร์/อีเมล์/บริษัท"
                            className="form-control mb-2"
                            onInput={onFilter}
                            value={lastFilter}
                        /> */}

                        <div className="add-member-to-group-modal-body" style={{ overflow: "auto" }}>
                            <table className="table table-bordered table-striped chat-table">
                                <thead className="thead-dark">
                                    <tr>
                                        <th>ชื่อผู้ใช้งาน</th>
                                        <th>มือถือ</th>
                                        <th>อีเมล์</th>
                                        {/* <th>ชื่อลูกค้า</th> */}
                                        <th>ห้องแชท</th>
                                        <th>จับคู่อยู่กับผู้ใช้ Chat.2S</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(findDConnectUsers || []).filter((x: any) => x.webUserID).map((item: any, key: number) => {
                                        const webUserType = item.webUserType === 1 ? "Admin" : item.webUserType === 2 ? "จัดซื้อ" : item.webUserType === 3 ? "บัญชี" : "";
                                        const isSameWebUser = userInfo?.webUserId == item.webUserID;
                                        return (
                                            <tr key={key} >
                                                <td style={isSameWebUser ? { backgroundColor: "var(--m2-wp-filter-emp-textbox-bd)" } : undefined}>
                                                    {item.fullName}
                                                    {webUserType && (<span className="bs-badge bs-badge-secondary rounded ms-1">{webUserType}</span>)}
                                                    {!item.webUserIsActive && (<span className="badge badge-soft-primary rounded ms-1 bg-danger">In Active</span>)}
                                                </td>
                                                <td style={isSameWebUser ? { backgroundColor: "var(--m2-wp-filter-emp-textbox-bd)" } : undefined}>{item.mobile}</td>
                                                <td style={isSameWebUser ? { backgroundColor: "var(--m2-wp-filter-emp-textbox-bd)" } : undefined}>{item.eMail}</td>
                                                {/* <td>{item.customerName}</td> */}
                                                <td style={isSameWebUser ? { backgroundColor: "var(--m2-wp-filter-emp-textbox-bd)" } : undefined}>
                                                    {item.inChatRooms ? (
                                                        <span className={Utils.GetCssSuffixTheme("spn-info-hilight")}>{item.inChatRooms}</span>
                                                    ) : (
                                                        <span onClick={() => onApplyWebUserToChat(item.webUserID, item.fullName, item.customerName)} className="text-red">ยังไม่ได้จับคู่</span>
                                                    )}

                                                </td>
                                                <td style={isSameWebUser ? { backgroundColor: "var(--m2-wp-filter-emp-textbox-bd)" } : undefined}>{item.mapWithChatUserName ? item.mapWithChatUserName : "ยังไม่จับ"}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>


                    </div>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="link" className="btn" onClick={onModalClose} >
                    ปิด
                </Button>
                {/* <Button
                    type="button"
                    color="primary"
                    // disabled={!valid}
                    onClick={() => onInvite(data)}
                >
                    Invite
                </Button> */}
            </ModalFooter>
        </Modal>
    );
};

export default SearchWebUserModal;
